import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading deve ser usado dentro de LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({});

  const setLoading = (key, isLoading, message = 'Carregando...') => {
    setLoadingStates(prev => ({
      ...prev,
      [key]: isLoading ? { loading: true, message } : undefined
    }));
  };

  const isLoading = (key) => {
    return !!loadingStates[key]?.loading;
  };

  const getLoadingMessage = (key) => {
    return loadingStates[key]?.message || 'Carregando...';
  };

  const isAnyLoading = () => {
    return Object.values(loadingStates).some(state => state?.loading);
  };

  const getGlobalLoadingMessage = () => {
    const activeStates = Object.values(loadingStates).filter(state => state?.loading);
    return activeStates.length > 0 ? activeStates[0].message : '';
  };

  return (
    <LoadingContext.Provider 
      value={{
        setLoading,
        isLoading,
        getLoadingMessage,
        isAnyLoading,
        getGlobalLoadingMessage
      }}
    >
      {children}
      {isAnyLoading() && (
        <div className="loading-overlay">
          <div className="loading-spinner-large">
            <div className="spinner"></div>
            <div className="loading-text">{getGlobalLoadingMessage()}</div>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
